import { useCallback } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useAnnouncement } from './useAnnouncement'
import { getNotificationLink } from '../lib/notificationLinks'
import type { Notification } from '../lib/api'

/**
 * What clicking a notification should do.
 *
 * Most types deep-link via getNotificationLink. The survey invite is special:
 * its deep-link is `/?announcement=survey`, which yanks the user to Home just
 * to pop a modal. Since AnnouncementDialog is mounted on every Layout page
 * (everything except /workspace), we instead open it *in place* — the user
 * stays wherever they were. We only fall back to the Home deep-link from
 * /workspace, where the modal isn't mounted.
 */
export function useActivateNotification() {
  const navigate = useNavigate()
  const location = useLocation()
  const { openDialog } = useAnnouncement()

  return useCallback(
    (notif: Notification) => {
      if (notif.type === 'survey_invite' && !location.pathname.startsWith('/workspace')) {
        openDialog()
        return
      }
      const link = getNotificationLink(notif)
      if (link) navigate(link)
    },
    [navigate, location.pathname, openDialog],
  )
}
